import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import AccountUserListPageUI from './AccountUserListPageUI.js'

class AccountUserListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      accountUserList: null,
      filteredAccountUserList: null,
      allRoleList: [],
      nonOwnerRoleList: [],
      // filters
      roleFilter: '-1',
      searchFilter: '',
      //
      successMsg: null,
      errorList: null,
      updateMode: false,
      deleteMode: false,
      submitted: false,
      selectedCount: 0,
      // update form
      roleId: '',
      roleList: []
    }
  }

  render() {
    return (
      <AccountUserListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        accountUserList={this.state.accountUserList}
        filteredAccountUserList={this.state.filteredAccountUserList}
        // filters
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onRoleFilterChange={this.onRoleFilterChange}
        allRoleList={this.state.allRoleList}
        roleFilter={this.state.roleFilter}
        // form
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        // modes
        selectedCount={this.state.selectedCount}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        submitted={this.state.submitted}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        onConfirmInviteClick={this.onConfirmInviteClick}
        onConfirmUpdateClick={this.onConfirmUpdateClick}
        onConfirmDeleteClick={this.onConfirmDeleteClick}
        onCancelClick={this.onCancelClick}
        // update form
        roleId={this.state.roleId}
        roleList={this.state.roleList}
        onRoleIdChange={this.onRoleIdChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccountUsers(context)
    this.getMessages(context)
    this.getRoles(context)
    // https://stackoverflow.com/questions/48269381/warning-react-modal-app-element-is-not-defined-please-use-modal-setappeleme
    Modal.setAppElement('body')
  }

  getAccountUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/users`,
      cacheKey: CacheKeys.AccountUsers(context.session.accountId),
      callback: this.getAccountUsersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountUsersCallback = (response) => {
    response.accountUserList && response.accountUserList.forEach(accountUser => {
      accountUser.selected = false
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.AccountUsersFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.accountUserList,
      filters.searchFilter ? filters.searchFilter : '',
      filters.roleFilter ? filters.roleFilter : '-1')
  }

  applyFilters(accountUserList, searchFilter, roleFilter) {
    let filteredList = accountUserList
    if (searchFilter)
      filteredList = filteredList.filter(user => user.name.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))
    if (roleFilter !== '-1')
      filteredList = filteredList.filter(user => user.roleId === roleFilter)

    // remove checked flag from rows that are hidden
    let selectedSet = new Set()
    accountUserList.filter(user => user.selected).forEach(user => {selectedSet.add(user.userId)})
    accountUserList.forEach(user => {user.selected = false})
    filteredList.filter(user => selectedSet.has(user.userId)).forEach(user => {user.selected = true})

    this.setState({
      accountUserList : accountUserList,
      filteredAccountUserList: filteredList,
      searchFilter: searchFilter,
      roleFilter: roleFilter,
      selectedCount: filteredList.filter(user => user.selected).length
    })

    let filters = {searchFilter: searchFilter, roleFilter: roleFilter}
    sessionStorage.setItem(CacheKeys.AccountUsersFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.AccountUsers(context.session.accountId))
    this.setState({errorList: null, accountUserList: null})
    this.getAccountUsers(context)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.accountUserList, searchFilter, this.state.roleFilter)
  }

  onRoleFilterChange = (value) => {
    this.setState({roleFilter: value})
    this.applyFilters(this.state.accountUserList, this.state.searchFilter, value)
  }

  onRowClick = event => {
    event.stopPropagation()
    let userId = event.currentTarget.getAttribute('data-row-id')
    let accountUserList = this.state.accountUserList
    accountUserList
      .filter(accountUser => accountUser.userId === userId && !accountUser.accountOwner)
      .forEach(accountUser => {
      accountUser.selected = !Boolean(accountUser.selected)
    })

    this.setState({accountUserList : accountUserList})
    this.applyFilters(accountUserList, this.state.searchFilter, this.state.roleFilter)
  }

  onUpdateClick = () => {
    // prepare role list
    let multiRole = false
    let firstRoleId = null
    this.state.filteredAccountUserList.filter(user => user.selected).forEach(user => {
      if (!firstRoleId)
        firstRoleId = user.roleId
      else if (firstRoleId !== user.roleId)
        multiRole = true
    })

    let roleList = this.state.selectedCount === 1 ? this.state.allRoleList : this.state.nonOwnerRoleList
    if (!multiRole)
      roleList = roleList.filter(role => role.key !== firstRoleId)

    let roleId = roleList.length > 0 ? roleList[0].key : ''

    this.setState({updateMode: true, roleList: roleList, roleId: roleId})
  }

  onDeleteClick = () => {
    this.setState({deleteMode: true})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, deleteMode: false, errorList: null})
  }

  onRoleIdChange = (event) => {
    this.setState({roleId: event.target.value})
  }

  onConfirmUpdateClick = () => {
    this.setState({submitted: true})
    let userIds = this.state.accountUserList
      .filter(accountUser => accountUser.selected)
      .map(accountUser => accountUser.userId)
      .toString()

    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/users/${userIds}`,
      this.onConfirmUpdateOrDeleteCallback, {
        roleId: this.state.roleId,
      }
    )
  }

  onConfirmDeleteClick = () => {
    let context = this.props.context
    this.setState({submitted: true})
    let userIds = this.state.accountUserList
      .filter(accountUser => accountUser.selected)
      .map(accountUser => accountUser.userId)
      .toString()

    RestApiUtils.delete(context,
      `/api/accounts/${context.session.accountId}/users/${userIds}`,
      this.onConfirmUpdateOrDeleteCallback
    )
  }

  onConfirmUpdateOrDeleteCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
      this.setState({submitted: false, errorList: errorList})
      return
    }

    let accountUserList = this.state.accountUserList

    if (this.state.updateMode) {
      // update original account user list with returned account users
      accountUserList = this.state.accountUserList.map(accountUser => {
        accountUser.selected = false
        let responseAccountUser = response.accountUserList
          .filter(responseAccountUser => accountUser.userId === responseAccountUser.userId)
        if (responseAccountUser.length === 1)
          responseAccountUser[0].selected = false
        return responseAccountUser.length === 1 ? responseAccountUser[0] : accountUser
      })
    }
    else {
      // remove returned account user list from original list
      accountUserList = accountUserList.filter(accountUser =>
        response.accountUserList.filter(responseAccountUser => accountUser.userId === responseAccountUser.userId).length === 0
      )
    }

    this.setState({
      submitted: false,
      accountUserList: accountUserList,
      successMsg: response.success,
    })

    let context = this.props.context
    CacheManager.removeObject(CacheKeys.AccountUsers(context.session.accountId))
    // also need to remove projects and project users cache as deleted users are removed from project
    CacheManager.removeByPrefix('TaskTree')
    CacheManager.removeByPrefix('ProjectUsers')

    // check if current user is in the list
    let currentUser = response.accountUserList.filter(accountUser => accountUser.userId === context.session.userId)
    if (this.state.updateMode && currentUser.length > 0) {
      this.getPermissions(context.session.accountId, context.session.userId)
    }

    this.applyFilters(accountUserList, this.state.searchFilter, this.state.roleFilter)

    setTimeout(() => {
      this.setState({updateMode: false, deleteMode: false, successMsg: null})
    }, 2000);
  }

  onConfirmDeleteCallback_delete = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
      this.setState({submitted: false, errorList: errorList})
      return
    }

    let accountUserList = this.state.accountUserList
    let newAccountUserList = accountUserList.filter(accountUser => !accountUser.selected)

    this.setState({
      submitted: false,
      accountUserList: newAccountUserList,
      successMsg: response.success
    })

    let context = this.props.context
    CacheManager.removeObject(CacheKeys.AccountUsers(context.session.accountId))

    this.applyFilters(accountUserList, this.state.searchFilter, this.state.roleFilter)

    setTimeout(() => {
      this.setState({deleteMode: false, successMsg: null})
    }, 2000);
  }

  getPermissions = (accountId, userId) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Permissions(context.session.accountId, context.session.userId))
    let cacheManager = new CacheManager({
      resource: `/api/user/accounts/${accountId}/permissions`,
      cacheKey: CacheKeys.Permissions(accountId, userId),
      callback: this.getPermissionsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPermissionsCallback = (response) => {
    let context = this.props.context
    context.permissions = response.permissionList
    context.onContextChange(context)
  }

  getRoles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/roles/account/locales/${context.locale}`,
      cacheKey: CacheKeys.Roles('account', context.locale),
      callback: this.getRolesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getRolesCallback = (response) => {
    let allRoleList = response.roleList.map(role => ({key: role.roleId, value: role.roleName}))
    let nonOwnerRoleList = response.roleList.filter(role => !role.ownerRole).map(role => ({key: role.roleId, value: role.roleName}))
    this.setState({
      allRoleList: allRoleList,
      nonOwnerRoleList: nonOwnerRoleList,
    })
  }

  getMessages(context) {
    let arr = [
      'c_account_users',
      //
      'c_all',
      'c_refresh',
      'c_invite_user',
      //
      'c_active',
      'c_inactive',
      'c_invited',
      // update
      'c_update_users',
      'c_update',
      'c_cancel',
      'c_new_role',
      // remove
      'c_remove_users',
      'c_remove_users_conf',
      'c_yes_remove',
      'c_do_not_remove',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_users', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default AccountUserListPageSF
